import React from 'react';

const AdminLogin = ({ usernameInput, setUsernameInput, passwordInput, setPasswordInput, handleAdminLogin }) => {
  return (
    <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center p-4 font-space">
      <form onSubmit={handleAdminLogin} className="glass-card p-10 rounded-[2rem] w-full max-w-md text-center text-white border border-[#333333] shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-[#F25C05] shadow-[0_0_15px_rgba(242,92,5,0.5)]"></div>
        <div className="mx-auto mb-5 flex h-24 w-24 items-center justify-center rounded-3xl border border-[#F25C05]/30 bg-[#111] p-2 shadow-[0_0_28px_rgba(242,92,5,0.18)]">
          <img
            src="/pizza-alif-logo.png"
            alt="Pizza Alif"
            className="h-full w-full object-contain"
          />
        </div>
        <p className="text-[#F25C05] text-[10px] uppercase tracking-[0.35em] mb-2 font-black">Welcome To</p>
        <h2 className="text-3xl font-black mb-2 italic tracking-tighter text-white">Pizza Alif ERP</h2>
        <p className="text-gray-500 text-xs uppercase tracking-[0.3em] mb-8 font-bold">Admin Authentication</p>
        
        <input 
          type="email" 
          placeholder="Email Address" 
          className="w-full p-4 bg-[#0d0d0d] rounded-xl mb-4 border border-[#333333] outline-none font-bold text-center focus:border-[#F25C05] transition-all text-white placeholder:text-gray-700" 
          value={usernameInput} 
          onChange={(e) => setUsernameInput(e.target.value)} 
          autoFocus 
          required
        />

        <input 
          type="password" 
          placeholder="Password" 
          className="w-full p-4 bg-[#0d0d0d] rounded-xl mb-6 border border-[#333333] outline-none font-bold text-center focus:border-[#F25C05] transition-all text-white placeholder:text-gray-700" 
          value={passwordInput} 
          onChange={(e) => setPasswordInput(e.target.value)} 
          required
        />

        <button className="w-full bg-[#F25C05] py-4 rounded-xl font-black shadow-lg shadow-[#F25C05]/20 active:scale-95 transition-all text-white mt-2">
          SECURE LOGIN
        </button>

        <div className="mt-8 border-t border-[#333333] pt-5">
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-gray-600">
            Copyright 2026
          </p>
          <p className="mt-1 text-[10px] font-black uppercase tracking-[0.24em] text-[#F25C05]/80">
            A Product By Smart Solutions
          </p>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
